import { useTranslation } from "react-i18next";
import { Toaster } from "sonner";
import { Rocket, Users, Wrench, ArrowDown } from "lucide-react";
import IncubationForm from "@/components/IncubationForm";

const BENEFITS = [
  ["benefit_1_t", "benefit_1_d", Wrench],
  ["benefit_2_t", "benefit_2_d", Users],
  ["benefit_3_t", "benefit_3_d", Rocket],
];

export default function Incubate() {
  const { t } = useTranslation();

  return (
    <div className="pb-24">
      <Toaster richColors position="top-right" />

      {/* Hero */}
      <section className="relative band-dark circuit-bg overflow-hidden" aria-labelledby="incubate-title">
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-16 lg:pt-24 lg:pb-20">
          <div className="max-w-3xl">
            <div className="tag mb-5 rise-in">{t("incubate.eyebrow")}</div>
            <h1 id="incubate-title" className="font-display font-black text-white leading-[0.95] rise-in rise-in-1">
              <span className="block text-5xl sm:text-6xl lg:text-7xl tracking-tight">{t("incubate.title_a")}</span>
              <span className="block text-3xl sm:text-4xl lg:text-5xl text-amber mt-2">{t("incubate.title_b")}</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-white/85 max-w-2xl leading-relaxed rise-in rise-in-2">{t("incubate.intro")}</p>
            <a href="#apply" data-testid="incubate-cta-apply" className="mt-10 inline-flex items-center gap-2 bg-amber text-brand-deep px-6 py-3.5 font-semibold hover:brightness-105 transition rise-in rise-in-3">
              {t("incubate.cta_apply")} <ArrowDown className="w-4 h-4" aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 border-b border-ink/10" aria-label="What you get">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-4" data-testid="incubate-benefits">
          {BENEFITS.map(([tk, dk, Icon], i) => (
            <article key={tk} className={`bg-white border border-ink/10 p-7 border-t-4 rise-in rise-in-${i + 1}`} style={{ borderTopColor: ["#004888", "#00886A", "#F5A21C"][i] }}>
              <Icon className="w-6 h-6 text-brand mb-4" aria-hidden="true" />
              <h3 className="font-display font-bold text-brand text-lg leading-snug">{t(`incubate.${tk}`)}</h3>
              <p className="mt-3 text-ink/75 text-sm leading-relaxed">{t(`incubate.${dk}`)}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Apply */}
      <section id="apply" className="py-20 scroll-mt-20" aria-labelledby="incubate-apply-heading">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div className="tag mb-3">{t("incubate.form_eyebrow")}</div>
              <h2 id="incubate-apply-heading" className="font-display font-black text-brand text-3xl sm:text-4xl">{t("incubate.form_title")}</h2>
              <p className="mt-5 text-ink/75 leading-relaxed">{t("incubate.form_intro")}</p>
            </div>
          </div>
          <div className="lg:col-span-8 border border-ink/10 bg-surface p-6 lg:p-10">
            <IncubationForm />
          </div>
        </div>
      </section>
    </div>
  );
}
